import { EthereumClient, w3mConnectors, w3mProvider } from '@web3modal/ethereum'
import { configureChains, createConfig, mainnet } from 'wagmi'
import { sepolia, polygon, polygonMumbai, bsc, bscTestnet } from '@wagmi/core/chains'
import { sendTransaction, getNetwork } from '@wagmi/core'
import { toast } from 'react-toastify'

import { IWalletConnectAdapter } from './BlockchainAdapter.types'

const chains = [mainnet, sepolia, polygon, polygonMumbai, bsc, bscTestnet]
const projectId = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID as string

const { publicClient, webSocketPublicClient } = configureChains(chains, [
  w3mProvider({ projectId }),
])
export const wagmiConfig = createConfig({
  autoConnect: true,
  connectors: w3mConnectors({ projectId, chains }),
  publicClient,
  webSocketPublicClient,
})
export const ethereumClient = new EthereumClient(wagmiConfig, chains)

const handleSendRequest = async (params: any) => {
  let response
  try {
    response = await sendTransaction({
      to: params.to || '',
      account: params.from,
      value: params.data ? BigInt(0) : BigInt(params.value),
      ...(params.data ? { data: params.data } : {}),
      ...(params.chainId ? { chainId: params.chainId } : {}),
    })
  } catch (error) {
    console.error('error: ', error)
    toast.error('Could not send transaction with WalletConnect')
    throw error
  }
  return response?.hash
}

const handleCheckChainMatch = (chainId: number) => {
  const connectedNetwork = getNetwork()
  return connectedNetwork.chain?.id === chainId
}

class WalletConnectAdapter implements IWalletConnectAdapter {
  public provider = ethereumClient

  async sendTransaction(params: any): Promise<any> {
    // if (
    //   evmNetworkIds[selectedChain][network] &&
    //   chain?.id !== evmNetworkIds[selectedChain][network]
    // ) {
    //   await switchNetwork({
    //     chainId: evmNetworkIds[selectedChain][network] as number,
    //   });
    //   console.log("switched network");
    // }
    return new Promise((resolve) => {
      // console.log("Signing transaction with WalletConnect...");
      resolve(handleSendRequest(params))
    })
  }
  async estimateGas(): Promise<any> {
    // return await handleEstimateGas(tx, value, sourceAddress, targetAddress, selectedToken)
  }

  checkChainMatch(chainId: number): boolean {
    return handleCheckChainMatch(chainId)
  }
}

export default WalletConnectAdapter
